import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Observer } from "mobx-react";
import myStore from "./store";
import CustomTable from "@components/CustomTable";
import { fetchDynamicFilters, transformData } from "@helpers/helpers";
import {
  DEFAULT_MONTH_RANGE,
  TRIM_CURRENT_DATE,
  PINNING_INITIAL_STATE,
  FIRST_INDEX,
} from "./constants";
import {
  buildLegendData,
  buildColumns,
  buildFilterDisplayValues,
  buildFilters,
  buildSelectedFiltersDisplay,
} from "./tableConfig";
import { buildActions } from "./actionsConfig";
import TriggerTypeCell from "./TriggerTypeCell";
import RevocationConfirmation from "./RevocationConfirmation";

const DataAcquisitionsInstances = () => {
  const { t: translate, i18n } = useTranslation();

  const [currentDateTime, setCurrentDateTime] = useState("");
  const [dynamicFilters, setDynamicFilters] = useState([]);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [revocableStats, setRevocableStats] = useState({});

  useEffect(() => {
    const today = new Date();
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(today.getMonth() - DEFAULT_MONTH_RANGE);

    const formattedDateTime = today
      .toISOString()
      .slice(FIRST_INDEX, TRIM_CURRENT_DATE);
    setCurrentDateTime(formattedDateTime);
    fetchDynamicFilters("DAInstanceFilters", (newFilters) => {
      setDynamicFilters(newFilters);
    });
  }, []);

  const getDynamicFilters = (key, onlyChildren = false) => {
    return transformData(
      (!!dynamicFilters &&
        !!dynamicFilters.length &&
        dynamicFilters.find((filter) => filter.ColumnName === key)?.Values) ||
        [],
      onlyChildren
    );
  };

  // Build configuration objects using helper functions
  const legendData = buildLegendData(translate);
  const columns = buildColumns(translate, legendData);
  const filterDisplayValues = buildFilterDisplayValues(translate);
  const filters = buildFilters(translate, getDynamicFilters, currentDateTime);
  const selectedFiltersDisplay = buildSelectedFiltersDisplay(translate);
  const actions = buildActions(translate, myStore, (stats) => {
    setRevocableStats(stats);
    setOpenConfirmation(true);
  });

  const multipleValueColumns = columns
    .filter((column) => column.isMultiple)
    .map((column) => column.accessorKey);

  return (
    <Observer>
      {() => {
        return (
          <>
            <CustomTable
              store={myStore}
              loading={myStore.loading}
              columnsWithoutPin={columns}
              pinCondition={(row) => {
                return false;
              }}
              filterDisplayValues={filterDisplayValues}
              selectedFiltersDisplay={selectedFiltersDisplay}
              filters={filters}
              pinningInitialState={PINNING_INITIAL_STATE}
              setParentSelectedValues={() => {}}
              actions={actions}
              prefix="DataAcquisitionsInstances"
              title={translate("data-acquisition-instances.title")}
              multipleValueColumns={multipleValueColumns}
              pinnedRowHeight={55}
              headerHeight={38}
              maxTableHeight={"calc(100dvh - 340px)"}
              language={i18n.language}
            />
            <RevocationConfirmation
              isOpen={openConfirmation}
              revocableStats={revocableStats}
              store={myStore}
              onClose={setOpenConfirmation}
            />
          </>
        );
      }}
    </Observer>
  );
};
export default DataAcquisitionsInstances;
